<div
  class="modal-header border-bottom-0 mb-2 cursor-move"
  cdkDrag
  cdkDragHandle
  cdkDragRootElement=".modal-content"
>
  <h3 class="p-0 m-0 text-white">
    {{ data.title | translate }}
  </h3>
  <button
    (click)="close()"
    class="modal-close-btn btn outline-none border-none px-0"
    type="button"
  >
    <img
      alt="Modal close icon"
      src="./assets/media/svg/closeIcon.svg"
      width="24px"
    />
  </button>
</div>
<ng-template appHost></ng-template>
